import { useLocation } from 'react-router-dom';

import { useSignupStepper } from '@front/pro/src/hooks/use-signup-stepper';
import { useUniverse } from '@front/pro/src/signup/signup-form-context';

import { getStep } from '../routes/routes';

import { useShowIntro } from './use-show-intro';
import { useShouldShowRevenueSimulator } from './use-show-revenue-simulator';

export const useWebStepper = () => {
  const shouldShowRevenueSimulator = useShouldShowRevenueSimulator();
  const location = useLocation();
  const currentStep = getStep(location.pathname);
  const { universe } = useUniverse();

  const stepper = useSignupStepper({
    currentStep,
    shouldShowRevenueSimulator,
    universe: universe!,
  });

  useShowIntro({ show: stepper.currentIndex === 0, universe });

  return {
    ...stepper,
    currentStep,
    stepConfig: {
      ...stepper.stepConfig,
      shouldShowProgressBar: stepper.currentIndex === 0 ? false : stepper.stepConfig?.shouldShowProgressBar,
    },
  };
};
